import React from 'react';
import IconSettings from '@salesforce/design-system-react/components/icon-settings';
import Spinner from '@salesforce/design-system-react/components/spinner';
import SnackBar from '../Shared/SnackBar';
import PriceLookupHeader from './PriceLookupHeader';
import PricingHeader from '../Usage/UsageDetails/UsageTabs/Pricing/PricingHeader';
import PriceLookupTabularDetails from './PriceLookupTabularDetails';
import PriceLookupModal from './PriceLookupModal/PriceLookupModal';
import useData from './hooks/useData';
import useSnackBar from '../../util/customHooks/useSnackBar';
import './index.scss';
import { PRICING_LIST_CONFIG } from '../../util/constants';

const PriceLookup: React.FC = () => {
  const {
    selectedAccount,
    selectedContract,
    filteredProducts,
    selectedProducts,
    pricingItems,
    error,
    isModalOpen,
    loader,
    loadingAccounts,
    loadingCatalog,
    loadingContractProducts,
    filteredAccountOptions,
    handleAccountSelect,
    handleSetItems,
    handleProductAdd,
    handleQuantityChange,
    setSearchText,
    setAccountSearchTerm,
    setContractSearchTerm,
    setIsModalOpen,
    setSelectedAccount,
    setSelectedContract,
    handleReset,
    Reset,
    setProductSearchTerm,
    setActiveTab,
    getUoM,
  } = useData();
  const { open, notification } = useSnackBar();
  const totalQuantity = selectedProducts.reduce((total, product) => total + product.quantity, 0);
  return (
    <IconSettings iconPath="/icons">
      <SnackBar open={open} notification={notification} />
      <div className="slds-p-horizontal_large slds-p-vertical_x-large">
        <PriceLookupHeader
          label="Price Catlog"
          handleOrderSearch={() => setIsModalOpen(true)}
          Reset={Reset}
        />
        <PricingHeader count={totalQuantity} viewOnly={false} />
        <PriceLookupTabularDetails
          items={pricingItems}
          setItems={handleSetItems}
          viewOnly={false}
          isAssignUser={false}
          pricingListConfig={Object.values(PRICING_LIST_CONFIG)}
          getUoM={getUoM}
        />
      </div>
      {isModalOpen && (
        <PriceLookupModal
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          error={error}
          filteredAccountOptions={filteredAccountOptions}
          filteredContractOptions={[]}
          loadingAccounts={loadingAccounts}
          loadingContracts={false}
          selectedAccount={selectedAccount}
          selectedContract={selectedContract}
          handleAccountSelect={handleAccountSelect}
          handleContractSelect={() => {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
          }}
          setAccountSearchTerm={setAccountSearchTerm}
          setContractSearchTerm={setContractSearchTerm}
          loadingSubInventory={loadingCatalog}
          setSearchText={setSearchText}
          filteredProducts={filteredProducts}
          handleQuantityChange={handleQuantityChange}
          selectedProducts={selectedProducts}
          handleProductAdd={handleProductAdd}
          setSelectedAccount={setSelectedAccount}
          setSelectedContract={setSelectedContract}
          setProductSearchTerm={setProductSearchTerm}
          loadingContractProducts={loadingContractProducts}
          handleReset={handleReset}
          setActiveTab={setActiveTab}
          totalQuantity={totalQuantity}
        />
      )}
      {loader && <Spinner size="medium" />}
    </IconSettings>
  );
};

export default PriceLookup;
